import { Action, createReducer, on } from '@ngrx/store';
import { initialFareRulesState, FareRulesState } from './fare-rules.state';
import { setFareRulesState } from './fare-rules.actions';

const featureReducer = createReducer(
  initialFareRulesState,
  on(
    setFareRulesState,
    (state, { fareBasisCodes, classOfServiceOrBookingCodes, operationalCarrierCodes, endorsements }) =>
      ({
        ...state,
        fareBasisCodes,
        classOfServiceOrBookingCodes,
        operationalCarrierCodes,
        endorsements,
      }) as FareRulesState
  )
);

export function fareRulesReducer(state = initialFareRulesState, action: Action) {
  return featureReducer(state, action);
}
